import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { AttachFilesFromExistingDocsExecutorModal } from './AttachFilesFromExistingDocsExecutorModal';
import { IAttachFilesFromExistingDocsExecutorProps } from './IAttachFilesFromExistingDocsExecutorProps';

export const AttachFilesFromExistingDocsExecutor = createDocModalExecutor<IAttachFilesFromExistingDocsExecutorProps>({
    modal: AttachFilesFromExistingDocsExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        action: action,
        completeHandler,

        payloadData: action.options.actionData,
        docData: action.options.docData,
    }),
});
